import React from "react";
import TableModal from '../../../../UI/TableModal';
import { isSet } from '../../../../../Utils/CommonFunctions'
import {callGET} from '../../../../../Utils/ApiUtil';
import Wrp from '../../../../../hoc/Wrp/Wrp';
import QuickCreateForms from '../../../../../Containers/LayoutContainer/QuickCreateForms';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import * as actions from '../../../../../store/actions';
class MultiUserModel extends React.Component{
    
    constructor(props) {
        super(props);
        this.state = {
            isModalOpen:this.props.isModalOpen,
            status:null,
            lookup_layout:this.props.lookup_layout,
            page:this.props.page,
            isConfirmPage:false,
            tableRecords:{
              tableHead:[],
              tableData:[], 
              pagination:{
                page:0,
                orderBy:'',
                perPage:10,
                direction:'ASC',
                totalRecords:0,
                search:''
              }
            },
            selectedValueCustom: '',
            multipleUserDisplayName:[]
        }
      }
      componentDidUpdate = (prevProps) => { 
        if(prevProps !==this.props) {
          this.setState({isModalOpen:this.props.isModalOpen,selectedValueCustom:this.props.selectedValue,multipleUserDisplayName:this.props.multipleUserDisplayName})
          if(prevProps.isModalOpen !== this.props.isModalOpen && this.props.isModalOpen===true){
            this.LayoutsFormsList(this.state.tableRecords.pagination,true);
          }
        }
        if(this.state.tableData===null){
            this.LayoutsFormsList(this.state.tableRecords.pagination,true);
        }
        
      }
      componentDidMount = () =>{
          this.setState({selectedValueCustom:this.props.selectedValue});
      }
      
      //MODAL CONFIRM
      confirmLoopupModalHandler = () => {
        let selectedValueList = this.state.selectedValueCustom.split(',');
        const tableDataSel = this.state.tableRecords;
        let multiUserDisplayList = [];
        if(selectedValueList!==null && selectedValueList.length>0){
          selectedValueList.map((value)=>{
            tableDataSel.tableData.data.map((item,index)=>{
              if(item.rowId===value){
                const tableDataCol = tableDataSel.tableData.data[index].data;
                let displayName = [];
                displayName.push(tableDataCol.firstName.value+' '+tableDataCol.lastName.value);
                multiUserDisplayList.push({
                  text:displayName.join(','),
                  label:displayName.join(','),
                  id:value,
                  value:value
                })
              }
            })
          });
        }
        this.props.setMultiLookupValuesFromList({
          multiUserDisplayList:multiUserDisplayList,
          value:this.state.selectedValueCustom,
          label:''
        })
          this.props.cancelLoopupModalHandler()
      }
      openQuickCreatePopup = () =>{
        this.setState({isQuickAddModalOpen:true});
      }
      //MODAL POPUP - CANCEL
      closeQuickCreatePopup = () =>{
        this.setState({isQuickAddModalOpen: false});
      }    
     recordsChangeHandler = (pagination)=>{
        this.LayoutsFormsList(pagination)
     }  
     goBackLookupList =()=>{
       this.LayoutsFormsList(this.state.tableRecords.pagination,true);
     }
     onChangeSelectLookup = (rowId,wthis)=>{
        const tableDataSel = this.state.tableRecords;
        let Checked =false;
        let multipleUserList=[];
        tableDataSel.tableData.data.map((item,index)=>{
            if(rowId===item.rowId){
                let isChecked = item.data.Checkbox.checked;
                Checked = isChecked;
                if(isChecked){
                    tableDataSel.tableData.data[index].className='';
                    tableDataSel.tableData.data[index].data.Checkbox.checked=false;
                    multipleUserList.splice(multipleUserList.findIndex(item => item.id === rowId), 1)
                }else{
                    tableDataSel.tableData.data[index].className='selected';
                    tableDataSel.tableData.data[index].data.Checkbox.checked=!isChecked;
                    const tableDataCol = tableDataSel.tableData.data[index].data;
                    let displayName = tableDataCol.firstName.value+' '+tableDataCol.lastName.value;
                    multipleUserList.push({
                      text:displayName,
                      label:displayName,
                      id:item.rowId,
                      value:item.rowId
                    })
                }
            }
        });
        if(Checked){
          tableDataSel.tableHead[0].checked=false;
        }
        var selectedValueList = isSet(this.state.selectedValueCustom,null)!==null?this.state.selectedValueCustom.split(','):[];
        if(selectedValueList!==null && selectedValueList.length>0){
          let found =false;
            selectedValueList.map((item,index)=>{
                if(item===rowId){
                    found =true;
                }
            })
            if(!found){
                selectedValueList.push(rowId);
            }else{
              selectedValueList.splice(selectedValueList.indexOf(rowId), 1);
            }
        }else{
          selectedValueList.push(rowId);
        }
    
        this.setState({tableRecords:{
            ...tableDataSel
          }, selectedValueCustom: (selectedValueList!==null && selectedValueList.length>0 )?selectedValueList.join(','):"",
          multipleUserDisplayName:multipleUserList
        })
        this.UpdateSelectAllCheckBox();
      }
      //Update SelectAllCheckBox 
      UpdateSelectAllCheckBox = ()=>{
        const tableDataSel = this.state.tableRecords;
        let updateTableData = tableDataSel;
        if(tableDataSel!==null && tableDataSel.tableHead!==null){
          let AllRecordSelected = true;
          tableDataSel.tableData.data.map((item,index)=>{
            if(!tableDataSel.tableData.data[index].data.Checkbox.checked){
              AllRecordSelected =false;
              return;
            }  
          })
        
          //update select all check box based on record selections
          updateTableData.tableHead[0].checked=AllRecordSelected;
          this.setState({tableRecords:{
            ...updateTableData
          }})
        }
        
      }
      //Select All Checkbox Handler
      OnClickSelectAllCheckBox =(e) =>{
        const tableDataSel = this.state.tableRecords;
        let selectedValueList=[];
        let multipleUserList=[];
        let Checked =tableDataSel.tableHead[0].checked;
          tableDataSel.tableData.data.map((item,index)=>{
            // let isChecked =item.data.Checkbox.checked;
            if(!Checked){
                tableDataSel.tableData.data[index].className='selected';
                tableDataSel.tableData.data[index].data.Checkbox.checked=true;
                selectedValueList.push(item.rowId);
                const tableDataCol = tableDataSel.tableData.data[index].data;
                let displayName = tableDataCol.firstName.value+' '+tableDataCol.lastName.value;
                multipleUserList.push({
                  text:displayName,
                  label:displayName,
                  id:item.rowId,
                  value:item.rowId
                })
            }else{
              tableDataSel.tableData.data[index].className='';
              tableDataSel.tableData.data[index].data.Checkbox.checked=false;
            }
          })
        tableDataSel.tableHead[0].checked=!Checked
        this.setState({tableRecords:{
              ...tableDataSel
        }, selectedValueCustom: (selectedValueList!==null&selectedValueList.length>0)?selectedValueList.join(','):"",
        multipleUserDisplayName
        :multipleUserList
      })
          
      }
      LayoutsFormsList =(pagination,loader=false) =>{
        const windowName = this.props.windowName;
        const page = pagination.page; 
        const orderBy = pagination.orderBy; 
        const perPage = pagination.perPage; 
        const direction = pagination.direction; 
        const search = pagination.search;
        this.setState({
          tableRecords:{
            ...this.state.tableRecords,
            pagination:pagination
          }
        })
        if(loader===true){ this.props.Loader(); }
        const queryString = '?query='+search+'&page='+page+'&orderBy='+orderBy+'&size='+perPage+'&direction='+direction;
        callGET('users/fetch-users/active'+queryString)
        .then(res => {
          if(loader===true){ this.props.Loader(); }
          if(res.status===200){ 
            const response = res.data;
            if(response.code===200){
              const resData = response.data;
              this.setState({lookup_layout:{
                // lookupLayoutId:resData.lookup_layout_id,
                moduleId:resData.module_id,
                windowId:resData.window_id,
                windowName:windowName
              }});
              let updateTableData = [];
              let fieldsRow;
              let tablehead = [
                {
                  name:'',
                  type:"Checkbox",
                  columnId:"",
                  isShow:true,
                  checked:false,
                  clickHandler : this.OnClickSelectAllCheckBox.bind(this),
                  attributes:{style:{width: "30px"}}
                },
                {
                  name:'First Name',
                  type:"HyperLink",
                  columnId:"",
                  isShow:true
                },
                {
                  name:'Last Name',
                  type:"HyperLink",
                  columnId:"",
                  isShow:true
                },
                {
                  name:'E-mail',
                  type:"HyperLink",
                  columnId:"",
                  isShow:true
                },
                {
                  name:'Contact number',
                  type:"HyperLink",
                  columnId:"",
                  isShow:true
                },
                {
                  name:'Profile',
                  type:"HyperLink",
                  columnId:"",
                  isShow:true
                },
                {
                  name:'Role',
                  type:"HyperLink",
                  columnId:"",
                  isShow:true
                }
              ]
              response.data.content.map((item,itemIndex)=>{
                fieldsRow = {}
                fieldsRow = {
                    ...fieldsRow,
                    Checkbox:{
                      checked:(this.state.selectedValueCustom && this.state.selectedValueCustom!=null && this.state.selectedValueCustom.includes(item.id))? true:false,
                      name:'windowCheckbox'
                    },
                    firstName:{
                      value:item.first_name,
                      className:'primary_color cursor-pointer'
                    },
                    lastName:{
                      value:item.last_name,
                      className:'primary_color cursor-pointer'
                    },
                    email:{
                      value:item.email
                    },
                    mobile_number:{
                      value:item.mobile_number
                    },
                    profile_name:{
                      value:item.profile_name
                    },
                    role_name:{
                      value:item.role_name,
                      className:'primary_color cursor-pointer'
                    }     
                }
              updateTableData.push({
                clickHandler:this.onChangeSelectLookup.bind(this,item.id),
                className:(this.state.selectedValueCustom && this.state.selectedValueCustom!=null && item.id===this.state.selectedValueCustom)? 'selected':'',
                rowId:item.id,
                data:fieldsRow
              })
            })  
              
              const totalRecords = response.data.total_elements;
              this.setState({status:200, tableRecords:{
                tableData:{data:updateTableData,status:200},
                tableHead:tablehead,
                pagination:{...this.state.tableRecords.pagination,totalRecords:totalRecords}
              }});
              this.UpdateSelectAllCheckBox();
            }else{
              const totalRecords = 0;//response.data.totalElements;
              this.setState({status:200, tableRecords:{
                tableData:{data:[],status:400},
                tableHead:this.state.tableRecords.tableHead ,
                pagination:{...this.state.tableRecords.pagination,totalRecords:totalRecords}
              }});
              this.UpdateSelectAllCheckBox();
            }
          }
        })
      }
      render () {
        const ModalTitle ="Multi User List";
        const modalType = 'tableList';
        const modalButtonList = [
            {
              attributes:{
                className:"btn btn btn-cancel mr-2",
                "data-dismiss":"modal",
                "id":"closeAddNewRoleModal",
              },
              clickHandler:this.props.cancelLoopupModalHandler,
              name:"Cancel"
            }
          ];
          const FooterButtonList = [
            {
              attributes:{
                className:"btn primary_bg cursor-pointer",
                "data-dismiss":"modal",
              },
              disabled:false,
              clickHandler:this.confirmLoopupModalHandler,
              name:"Confirm"
            }
          ];
        try{
          return (
            <Wrp>
            <TableModal 
              isModalOpen={this.state.isModalOpen}
              title={ModalTitle}
              modalType={modalType}
              buttonList={modalButtonList}
              tableRecords={this.state.tableRecords}
              FooterButtonList={FooterButtonList}
              recordsChangeHandler={this.LayoutsFormsList}
              selectedMultiLookupCount ={(this.state.selectedValueCustom && this.state.selectedValueCustom!=='')?this.state.selectedValueCustom.split(',').length:0}
              isConfirmPage={this.state.isConfirmPage}
               />
               {(this.state.isQuickAddModalOpen===true)?
                <QuickCreateForms 
                  succMessage={this.props.succMessage}
                  failMessage={this.props.failMessage}  
                  Loader={this.props.Loader}
                  closeQuickCreatePopup={this.closeQuickCreatePopup}
                  isQuickAddModalOpen={this.state.isQuickAddModalOpen}
                  lookup_layout={this.state.lookup_layout}
                  goBackLookupList={this.goBackLookupList}
                />  
             :''} 
            </Wrp>
          )
        }catch(e){
          this.props.failMessage("Something went wrong...");
        }
        
    }
}
const mapDispatchToProps = dispatch => {
    return {
      Loader : (bool) => dispatch(actions.loader(bool)),
      succMessage : (msg) => dispatch(actions.succMessage(msg)),
      failMessage : (msg) => dispatch(actions.failMessage(msg))    
    };
  }
export default 
connect(
    null, 
    mapDispatchToProps
  )(withRouter(MultiUserModel));